import { toastError, toastWarning } from '@components/Toast';

import { Types } from '@store/types';

import ApiClient, { routes } from '@lib/apiClient';

import {
	downloadBlobFIle,
	getSurveySettings,
	getUserInfo,
	getUserPreference,
	printApiError
} from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

export const fetchEnumValues = async (type, setData) => {
	try {
		const { data } = await ApiClient.GET('getEnums', type);
		let tmpData = data?.map((item) => {
			return {
				id: item.constant,
				text: item.name,
				value: item.constant,
				name: item.constant,
				label: item.name
			};
		});
		if (setData) {
			setData(tmpData);
		}
		return data;
	} catch {
		toastError('Unable to fetch enums!');
	}
};

export const fetchFabricSubCategory = async (type) => {
	try {
		let params = '';
		if (type) params = `?fabricType=${type}`;
		const { data } = await ApiClient.GET('getFabricSubCategory', params);
		return data;
	} catch (error) {
		toastError(error);
	}
};

export const fetchFabricCategory = async () => {
	try {
		const { data } = await ApiClient.GET('getFabricTypes');
		return data;
	} catch (error) {
		toastError(error);
	}
};

export const fetchDepartments = async () => {
	try {
		const { data } = await ApiClient.GET('getMarket');
		return data;
	} catch (error) {
		toastError(error);
	}
};

export const fetchCategoryAndSubCategories = async () => {
	try {
		const { data } = await ApiClient.GET('fetchSubCategory', '?size=1000&page=0');
		return data;
	} catch (error) {
		toastError(error);
	}
};

export const onRemoveColorFromMaterial = async (materialId, colorId) => {
	try {
		const { data } = await ApiClient.DELETE(
			'materialAction',
			{},
			`${materialId}/color-remove/${colorId}`
		);
		return data;
	} catch ({ response }) {
		if (response.data.message) {
			toastError(response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchCategories = async () => {
	try {
		const { data } = await ApiClient.GET('getDesignCategories', '?size=1000&page=0');
		return data;
	} catch (error) {
		toastError(error);
	}
};

export const fetchAllBrands = async (params = '') => {
	try {
		const { data } = await ApiClient.GET('getAllBrands', params);
		return data;
	} catch (error) {
		toastError(error);
	}
};

export const fetchBrands = async (params = '') => {
	try {
		const { data } = await ApiClient.GET('getBrandList', params);
		return data.data;
	} catch (error) {
		toastError(error);
	}
};

export const fetchBrandBasicList = async (params = '') => {
	try {
		const { data } = await ApiClient.GET('getBrandBasicList', params);
		return data.data;
	} catch (error) {
		toastError(error);
	}
};

export const fetchAllCountry = async () => {
	try {
		const { data } = await ApiClient.GET('getAllCountry');
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchSupplierCityByCountry = async (id) => {
	try {
		const { data } = await ApiClient.GET('getSupplierCityByCountry', id);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchMaterialUnitType = async () => {
	try {
		const { data } = await ApiClient.GET('fetchMaterialUnitType');
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const setSystemUserPreferences = async (newKeyValues) => {
	let body = getUserPreference();
	body = {
		...body,
		...newKeyValues
	};
	await ApiClient.POST('setSettingsData', {
		key: 'SYSTEM_PREFERENCES',
		value: JSON.stringify(body)
	})
		.then(() => {
			let userInfo = { ...getUserInfo() };
			userInfo.systemPreference = body;
			localStorage.setItem('userInfo', JSON.stringify(userInfo));
		})
		.catch(({ response }) => {
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			}
		});
};

export const setSurveySettings = async (surveyTypeDate, date) => {
	let body = getSurveySettings();
	body = {
		...body,
		[surveyTypeDate]: date
	};
	await ApiClient.POST('setSettingsData', {
		key: 'SURVEY_SETTINGS',
		value: JSON.stringify(body)
	})
		.then(() => {
			let userInfo = { ...getUserInfo() };
			userInfo.surveySettings = body;
			localStorage.setItem('userInfo', JSON.stringify(userInfo));
		})
		.catch(({ response }) => {
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			}
		});
};

export const setMailFrequency = async (mailFrequency) => {
	await ApiClient.POST('setSettingsData', {
		key: 'MAIL_FREQUENCY',
		value: mailFrequency
	})
		.then(() => {
			let userInfo = { ...getUserInfo() };
			userInfo.mailFrequency = mailFrequency;
		})
		.catch(({ response }) => {
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			}
		});
};

export const getMailFrequency = async (mailFrequency) => {
	try {
		const { data } = await ApiClient.GET('getSettingsData', mailFrequency);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const fetchProductRefferenceNumber = async (search) => {
	try {
		const { data } = await ApiClient.GET(
			'getProductRefferenceNumber',
			`?size=250&sort=referenceNumber,asc&page=0&search=${search}`
		);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchProductSearchHistory = async () => {
	try {
		const { data } = await ApiClient.GET('productSearchHistory', `?size=20&sort=createdAt,desc&page=0`);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const saveProductSearchHistory = async (postData) => {
	try {
		const { data } = await ApiClient.POST('productSearchHistory', postData);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchMaterialProducts = async (params, requestBody) => {
	try {
		const { data } = await ApiClient.POST('searchProduct', requestBody, params);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchSimilarMaterials = async (materialId) => {
	try {
		const { data } = await ApiClient.GET(
			'fetchSimilarMaterialApi',
			`?size=100&page=0&materialId=${materialId}`
		);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const uploadDocument = async (postData) => {
	try {
		const { data } = await ApiClient.POST('uploadDocument', postData);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const deleteProductDocument = async (productId, docId) => {
	try {
		const { data } = await ApiClient.DELETE('deleteProductDocument', '', `${productId}/${docId}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateLeadTime = async (postData) => {
	try {
		const { data } = await ApiClient.POST('updateLeadTime', postData);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const callProductTracker = async (productId) => {
	try {
		const { data } = await ApiClient.POST('trackProductById', '', productId);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchTeamBrands = async (params) => {
	try {
		const { data } = await ApiClient.GET('getTeamBrands', params);
		return data;
	} catch (error) {
		toastError(error);
	}
};

export const fetchUserByEmail = async (parmas) => {
	try {
		const { data } = await ApiClient.GET('getUserSuggestions', parmas);
		return data;
	} catch (err) {
		toastError(err.response.data.message);
	}
};

export const fetchFiberFabricList = async (parmas) => {
	try {
		const { data } = await ApiClient.GET('fetchFiberFabricList', parmas);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getProductInfoByProductId = async (params) => {
	try {
		const { data } = await ApiClient.GET('fetchProductInfo', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getProductInfoByProductIds = async (params) => {
	try {
		const { data } = await ApiClient.GET('fetchProductResponse', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchTrimsList = async (parmas) => {
	try {
		const { data } = await ApiClient.GET('fetchTrimsList', parmas);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getProductArtBoardsByProductId = async (params) => {
	try {
		const { data } = await ApiClient.GET('fetchArtBoard', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchAccessoriesList = async (parmas) => {
	try {
		const { data } = await ApiClient.GET('fetchAccessoriesList', parmas);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getGroupwiseDocByProductId = async (params) => {
	try {
		const { data } = await ApiClient.GET('getGroupwiseDoc', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getProductMaterialsByProductId = async (params) => {
	try {
		const { data } = await ApiClient.GET('getProductMaterials', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

const getSelectedFilterPageUrl = (pageType) => {
	let supplierUrl = `supplierDependentFilterList`;
	switch (pageType.type) {
		case 'SUPPLIER_LIST':
			return supplierUrl;
		case 'SALES_FUNNEL_DASHBOARD':
			return 'salesFunnelFilterOptions';
		case 'SAMPLE_LIST':
			return 'fetchSampleListPageFilter';
		case 'SAMPLE_DETAILS':
			return 'sampleDetailsAction';
		case 'COSTING_LIST':
			return 'fetchQuoteListPageFilter';
		case 'COSTING_DETAILS':
			return 'requestQuote';
		case 'INITIAL_COSTING_LIST':
			return 'fetchInitialCostingListPageFilter';
		case 'SAMPLE_DEVELOPMENT':
			return 'getProductsWithSampleItemByCollection';
		case 'POM_LIST':
			return 'getPomListPageFilter';
		case 'BLOCK_LIBRARY_CARD_VIEW_LIST':
			return 'getBlockCardViewFilterOptions';
		case 'BLOCK_LIBRARY_COLLECTION_VIEW_LIST':
			return 'getBlockCollectionViewFilterOptions';
		case 'BLOCK_SUGGESTIONS':
			return 'blockSuggestionFilterOptions';
		case 'SKETCH_LIST':
			return 'getSketchListFilterOptions';
		case 'ARTWORK_LIST':
			return 'getArtworkListFilterOptions';
		case 'COLLECTION_LIST':
			return 'collectionFilterOptions';
		case 'PRODUCT_LIST':
			return 'productListFilterOptions';
		case 'COSTING_LIST_STYLE_VIEW':
			return 'fetchInitialCostingDesignsFilterOptions';
		case 'FABRIC_LIST_TAB':
			return 'fabricFilterOptions';
		case 'TRIMS_LIST_TAB':
			return 'trimsListFilterOptions';
		case 'ACCESSORIES_LIST_TAB':
			return 'accessoriesListFilterOptions';
		case 'COLLECTION_DETAILS':
			return 'collectionDetailsFilterFields';
		case 'FAVOURITE_DETAILS':
			return 'favouriteDetailsFilterFields';
		case 'FAVOURITE_LIST':
			return 'getFavouriteListFilterOptions';
		default:
			return null;
	}
};

export const fetchDependentFilterList =
	(pageType, paramsData, requestType = 'GET', requestBody = {}) =>
	async (dispatch) => {
		try {
			let params = Object.keys(paramsData).length !== 0 ? paramsData : '';
			let url = routes[getSelectedFilterPageUrl(pageType)];
			if (pageType.idUrl) {
				url += pageType.idUrl;
			}
			const { data } =
				requestType === 'GET'
					? await ApiClient.GET(url, params, true)
					: await ApiClient.POST(url, requestBody, '', true);
			dispatch({
				type: Types.STORE_DEPENDENT_FILTER_LIST,
				payload: { responseData: data, filterListPage: pageType.type }
			});
		} catch (error) {
			printApiError(error);
		}
	};

export const startOrderByOrderId = async (orderId) => {
	try {
		const { data } = await ApiClient.POST(`${BASE_URL}/order/order/${orderId}/start-order`, '', '', true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const sendOrderToShipmentByOrderId = async (orderId) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/order/order/${orderId}/send-to-shipment`,
			'',
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateSupplierQuoteMargin = async (quoteId, nitexMargin) => {
	try {
		const { data } = await ApiClient.POST(
			'updateNitexMargin',
			'',
			`${quoteId}?nitexMargin=${nitexMargin}`
		);
		return data;
	} catch (error) {
		if (error?.response?.data?.message) {
			toastWarning(error.response.data.message);
		} else {
			toastError('Something went wrong!');
		}
	}
};

export const updateSupplierBulkQuote = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST('updateSupplierBulkQuote', requestBody);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const downloadTechPack = async (productId, currentTime) => {
	try {
		const { data } = await ApiClient.POST(
			'downloadTechPack',
			{ currentTime, downloadAllPages: true, showAllArtBoardPages: true },
			productId
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const findAllUsersByUserTypes = async (params) => {
	try {
		const { data } = await ApiClient.GET('getUsersByTypes', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const findUserBySearch = async (params) => {
	try {
		const { data } = await ApiClient.GET('getUserBySearch', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getOrganizationCountryList = async () => {
	try {
		const { data } = await ApiClient.GET('getCountryList');
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const downloadGMVReport = async (params) => {
	try {
		const response = await ApiClient.GET_FILE_DATA('downloadGMVReport', params);
		downloadBlobFIle(response);
	} catch (error) {
		printApiError(error);
	}
};

export const downloadNMVReport = async (params) => {
	try {
		const response = await ApiClient.GET_FILE_DATA('downloadNMVReport', params);
		downloadBlobFIle(response);
	} catch (error) {
		printApiError(error);
	}
};

export const downloadFabricInventoryReport = async (params) => {
	try {
		const response = await ApiClient.GET_FILE_DATA('inventoryReport', params);
		downloadBlobFIle(response);
	} catch (error) {
		printApiError(error);
	}
};

export const downloadNotificationReport = async (params) => {
	try {
		const response = await ApiClient.GET_FILE_DATA('downloadNotificationReport', params);
		downloadBlobFIle(response);
	} catch (error) {
		printApiError(error);
	}
};

export const fetchSubCategories = async () => {
	try {
		const { data } = await ApiClient.GET('getDesignSubCategories');
		return data;
	} catch (error) {
		toastError(error);
	}
};
export const fetchColleaguesDetails = async (id) => {
	try {
		const { data } = await ApiClient.GET('userStrengthInfo', id);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateColleaguesDetails = async (body) => {
	try {
		const { data } = await ApiClient.POST('userUpdateTag', body);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const submitLocationUpdate = async (param) => {
	try {
		const response = await ApiClient.PUT('updateCountryLocation', {}, param);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const downloadSKUReport = async (requestBody) => {
	try {
		const response = await ApiClient.UPLOAD_MULTIPLE_FILE('downloadSKUReport', requestBody, '');
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const getFabricCompositions = async () => {
	try {
		const { data } = await ApiClient.GET('getFabricCompositions');
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getFabricConstraction = async () => {
	try {
		const { data } = await ApiClient.GET('getFabricConstraction');
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const downloadUpdateTrackerReport = async (requestBody) => {
	try {
		const response = await ApiClient.DOWNLOAD('downloadUpdateTrackerReport', requestBody, '');
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const trackMixPanelEvent = (reqBody, eventName) => {
	try {
		ApiClient.POST('mixpanelAddEvent', reqBody, eventName);
	} catch {}
};
